import { useState } from "react";
import { allHeaderCategories } from "../../utils/headers";
import { StyledModal, StyledModalHeader } from "./FilterModalStyles";
import type {
  CheckBoxEventValue,
  InterstateOnChangeEvent
} from "@dealer-center/core-components";
import { Button, CheckBox } from "@dealer-center/core-components";
import type { FilterModalProps } from "@dealer-center/ddc-pages-inventory-archiver-interface";

const FilterModal = (props: FilterModalProps) => {
  const [shouldShowModal, setShowModal] = useState(false);
  const checkedCategories: string[] = props.checkedCategories;
  const onToggleHeaders = props.onToggleHeaders;

  const handleCheck = (e: InterstateOnChangeEvent<CheckBoxEventValue>) => {
    const val = e.target?.value?.checkboxValue || "";
    if (checkedCategories.includes(val)) {
      onToggleHeaders(
        checkedCategories.filter(key => key !== e.target?.value?.checkboxValue)
      );
    } else {
      onToggleHeaders([...checkedCategories, e.target?.value?.checkboxValue]);
    }
  };

  return (
    <>
      <Button
        analyticsConfiguration={{ eventName: "Header Filter Button Clicked" }}
        id="btnDefault"
        sx={{
          marginRight: "5px"
        }}
        onClick={() => setShowModal(true)}
      >
        Adjust Headers
      </Button>
      <StyledModal
        className="sample-modal-dialog"
        header={<StyledModalHeader>Adjust Headers</StyledModalHeader>}
        id="ModalDialog"
        show={shouldShowModal}
        size={"large"}
        onHide={() => setShowModal(false)}
      >
        {allHeaderCategories.map((keyString: string) => (
          <div key={keyString}>
            <CheckBox
              checked={checkedCategories.includes(keyString)}
              label={keyString}
              value={keyString}
              onChange={handleCheck}
            />
          </div>
        ))}
      </StyledModal>
    </>
  );
};

export default FilterModal;
